<template>
  <div class="app-main-content">
    <price-combination-result
      ref="priceCombinationResult"
      :trunk-line-enable="trunkLineEnable"
      :pre-port-enable="prePortEnable"
      :last-mile-enable="lastMileEnable"
      :trunk-line-data="trunkLineData"
      :pre-port-data="prePortData"
      :last-mile-data="lastMileData"
      :trunk-line-data-total="trunkLineDataTotal"
      :pre-port-data-total="prePortDataTotal"
      :last-mile-data-total="lastMileDataTotal"
      @pagination="p => $emit('pagination', p)"
    />
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import PriceCombinationResult from '@/components/Cargo/Price/priceCombinationResult'

export default {
  name: 'PriceCombinationStep2', // 询价-详情-匹配运价/报价、运价查询-整箱-组合查询
  components: { PriceCombinationResult },
  props: {
    type: { type: Number, default: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code }, // 运价/询价类型 1-海运整箱、 2-海运拼箱、 3-空运
    trunkLineEnable: { type: Boolean, default: true }, // 干线
    prePortEnable: { type: Boolean, default: true }, // 港前
    lastMileEnable: { type: Boolean, default: true }, // 尾程
    trunkLineData: { type: Array, default: () => [] },
    prePortData: { type: Array, default: () => [] },
    lastMileData: { type: Array, default: () => [] },
    trunkLineDataTotal: { type: Number, default: 0 },
    prePortDataTotal: { type: Number, default: 0 },
    lastMileDataTotal: { type: Number, default: 0 }
  }
}
</script>

<style scoped lang="scss">

</style>
